import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { supabase } from '../supabaseClient';
import { lidSuggestions, phoneDigits, phoneKey } from '../utils/customers';

const when = (iso) => (iso ? new Date(iso).toLocaleString('es-CO', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) : 'sin fecha');

// Se muestra justo después de silenciar un número. WhatsApp a veces entrega el chat como un contacto «sin número» (ID interno) y el bot no sabe
// que es esa persona: aquí se elige cuál es y se vincula su teléfono con la misma función de Clientes (si ya hay ficha con ese teléfono, las fusiona).
export default function LidLinkSuggestions({ businessId, phone, onClose }) {
  const [options, setOptions] = useState([]);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data, error } = await supabase
          .from('customers')
          .select('id, name, phone, lid, tags, last_contact_at, messages_count')
          .eq('business_id', String(businessId))
          .or(`tags.cs.{lid},phone.like.*${phoneKey(phone)}`);
        if (alive && !error) setOptions(lidSuggestions(data, phone));
      } catch {
        // Sin la tabla de clientes no hay nada que sugerir: silenciar funciona igual.
      }
    })();
    return () => { alive = false; };
  }, [businessId, phone]);

  if (!options.length) return null;

  const link = async (id) => {
    setBusy(true);
    const { error } = await supabase.rpc('link_customer_phone', { p_id: id, p_phone: phoneDigits(phone) });
    setBusy(false);
    if (error) { toast.error('No se pudo vincular el teléfono. Intenta de nuevo desde Clientes.'); return; }
    toast.success('Listo: el bot ya reconoce ese chat como el número silenciado.');
    onClose();
  };

  return (
    <div className="bg-amber-500/10 border border-amber-500/30 rounded-2xl p-4 space-y-2" role="region" aria-label="Vincular chat sin número">
      <p className="text-xs text-amber-200">
        <strong>+{phoneDigits(phone)} quedó silenciado.</strong> Si esa persona ya te escribió y su chat aparece sin número, elige cuál es para que el bot lo reconozca (si no, puede seguir respondiéndole):
      </p>
      <ul className="space-y-1.5">
        {options.map((c) => (
          <li key={c.id} className="flex items-center justify-between gap-2 bg-seryi-bg-dark border border-seryi-bg-light rounded-xl px-3 py-2 text-xs text-seryi-heading">
            <span className="min-w-0 truncate">{c.name || 'Sin nombre'} · ID …{String(c.lid || c.phone).slice(-6)} · último mensaje {when(c.last_contact_at)} · {c.messages_count || 0} msj</span>
            <button type="button" disabled={busy} onClick={() => link(c.id)} className="shrink-0 bg-seryi-green text-seryi-bg-dark font-bold px-3 py-1.5 rounded-lg disabled:opacity-50">Es este</button>
          </li>
        ))}
      </ul>
      <button type="button" onClick={onClose} className="text-[11px] text-seryi-text underline">No es ninguno</button>
    </div>
  );
}
